import React, { useState } from "react";
import { IconBulb } from "../Icons";

export default function SkillLoadBanner({ event }) {
  const [expanded, setExpanded] = useState(false);
  const names = event.payload?.skill_names || [];
  const text = event.payload?.text || "";
  return (
    <div className="ev ev--skill-load">
      <button
        className="ev-skill-load-header"
        onClick={() => setExpanded((v) => !v)}
        type="button"
      >
        <IconBulb size={14} />
        <span className="ev-skill-load-title">
          {names.length === 0
            ? "Skills loaded"
            : names.length === 1
            ? `Skill loaded: ${names[0]}`
            : `${names.length} skills loaded: ${names.join(", ")}`}
        </span>
        <span className="ev-skill-load-toggle">{expanded ? "Hide content" : "Show content"}</span>
      </button>
      {expanded && (
        <pre className="ev-skill-load-body">{text}</pre>
      )}
    </div>
  );
}
